import React from 'react'
import { t } from 'ttag'

const SkillsPanel = () => {
  return (
    <div>
      <div>
        <p>
          {t`The Skills Profiler allows you to identify the skills that you currently possess and 
                see a listing of occupations that can best utilize those skills.`}
        </p>
      </div>
      <div className="embed-responsive embed-responsive-16by9">
        <video
          className="embed-responsive-item"
          controls="true"
          poster={
            '/images/headed2/marketing/features/H2-Video-ToolDemo-Bookends-0720-v1_Skills-Profiler.jpg'
          }>
          <source
            src="https://s3.amazonaws.com/h2-marketing/SkillsProfiler.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  )
}

export default SkillsPanel
